const colors = {
    /*-- WALLMEK COLORS --*/

    /* Shades */
    black: "#282828", //Brand black
    black_10: "rgba(40, 40, 40, 0.1)", //Transparency/Black -10%
    black_30: "rgba(40, 40, 40, 0.3)", //Transparency/Black -30%
    black_50: "rgba(40, 40, 40, 0.5)", //Transparency/Black -50%
    black_70: "rgba(40, 40, 40, 0.7)", //Transparency/Black -70%
    black_90: "rgba(40, 40, 40, 0.9)", //Transparency/Black -90%
    white: "#ffffff", //Shades/White
    white_30: "rgba(255, 255, 255, 0.3)", //Transparency/White -30%
    white_50: "rgba(255, 255, 255, 0.5)", //Transparency/White -50%
    beige: "#f9f9f7", //Shades/Beige-bg

    /* Neutrals - Grayscale */
    neutral_50: "#f7f8f9", //Neutral/50
    neutral_100: "#e7eaee", //Neutral/100
    neutral_200: "#d0d5dd", //Neutral/200
    neutral_400: "#8a95a5", //Neutral/400
    neutral_500: "#64748b", //Neutral/500
    neutral_600: "#4B5768", //Neutral/600
    neutral_700: "#323a46", //Neutral/700
    neutral_800: "#191d23", //Neutral/800

    /* Brand Colors */
    blue_50: "#e8f3fb", //Primary/Blue-50
    blue_100: "#aed4f2", //Primary/Blue-100
    blue_200: "#86beeb", //Primary/Blue-200
    blue_700: "#134873", //Primary/Blue-700
    blue_900: "#0c2d48", //Primary/Blue-900
    yellow_300: "#fcd165", //Secondary/Yellow-300
    yellow_400: "#fbc53f", //Secondary/Yellow-400
    red_300: "#fca5a5",

    // bg_default:
    bg_blue: "#134873", //blue_700
    bg_darkBlue: "#0c2d48", //blue_900
    bg_grey: "#e7eaee", //neutral_100
    bg_darkGrey: "#4B5768", //neutral_600
    bg_yellow: "#fbc53f", //yellow_400
    bg_transparent: "transparent",

    /*-- INHERITED COLORS --*/
    orange: "#FF4D00",
    red: "#F4323F",
    redOpacity: "#F4323F80",
    green: "#00BA2C",
    lightGreen: "#D1EBD7",
    lightBlue: "#B9D9EB",
    lightPink: "#FFD6DA",
    lightOrange: "#FF4D0080",
    lightGreige: "#FBFAF9", // Greige 01
    greige: "#F7F6F3", // Greige 02
    darkGreige: "#EFECE7", // Greige 03
    darkGreen: "#004342",
    shadowGrey: "#E3E0DB",
    inStock: "#A7EAB6",
    lowStock: "#FFF222",
    outOfStock: "#F4323F",
    noStockInfo: "#969696",
    parametricColors: {
        blue: "#3678EE",
        red: "#F4323F",
        green: "#004342",
        pink: "#F897E2",
        black: "#000000",
        white: "#FFFFFF",
    },
    starYellow: "#E9BF59",

    // Gradients
    skeletonGradient: "linear-gradient(90deg, rgba(239, 236, 231, 0) 0%, #efefef 49.47%, rgba(239, 236, 231, 0) 100%)",

    // Old/Other
    lightGrey: "#F7F7F7",
    textGrey: "#BEBEBE",
    darkGrey: "#222222",
    hoverDarkGrey: "#2C2C2C",
    darkGreyTint: "#303030",
    bgGrey: "#E5E5E5",
    reviewsGreen: "#00B67A",
    badgeGrey: "#D0D5DD",
} as const;

export type ColorType = typeof colors;

export default colors;
